<template>
  <div>
    <v-dialog v-model="display" :width="width" persistent lazy full-width>
      <v-text-field
        slot="activator"
        :label="label"
        :value="formattedDatetime"
        box
        :disabled="disabled"
        :error-messages="getErrors(validator)"
        append-icon="schedule"
        readonly
        @blur="validator && validator.$touch()"
      />
      <v-card>
        <v-card-text style="padding: 0; height: 378px">
          <v-time-picker
            ref="timer"
            v-model="timePart"
            :format="timePickerFormat"
            full-width
            class="v-time-picker-custom"
            scrollable
            actions
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <main-button :text="cancelText" flat @click.native="cancelHandler" />
          <main-button :text="okText" depressed @click.native="okHandler" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { defaultMessages, getValidationErrors } from './../../../utils'

const DEFAULT_TIME_FORMAT = 'HH:mm'

export default {
  name: 'time-field',
  props: {
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    value: {
      type: [Date, String],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 320,
    },
    format: {
      type: String,
      default: 'HH:mm',
    },
    timePickerFormat: {
      type: String,
      default: '24hr',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    okText: {
      type: String,
      default: 'OK',
    },
    min: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
  },
  data() {
    this.value && this.$emit('input', this.value)

    return {
      display: false,
      timeSelected: false,
      selectedDatetime: this.value,
    }
  },
  computed: {
    timePart: {
      get() {
        const time = this.selectedDatetime
          ? this.selectedDatetime
          : moment(time).format(DEFAULT_TIME_FORMAT)
        return time
      },
      set(val) {
        this.timeSelected = true

        this.selectedDatetime = val
      },
    },
    formattedDatetime() {
      return this.value ? this.value : ''
    },
  },
  watch: {
    display(val) {
      if (val) {
        this.selectedDatetime = this.selectedDatetime
          ? this.selectedDatetime
          : moment(new Date(this.min || this.max || new Date())).format(DEFAULT_TIME_FORMAT)
      }
    },
  },
  methods: {
    getTime(input) {
      if (moment(this.selectedDatetime).startOf('day').isSame(moment(input).startOf('day'))) {
        return moment(input).format(DEFAULT_TIME_FORMAT)
      }
      return undefined
    },
    okHandler() {
      this.display = false
      this.selectedDatetime = this.selectedDatetime
        ? this.selectedDatetime
        : this.min || this.max || moment().format(DEFAULT_TIME_FORMAT)
      this.$emit('input', this.selectedDatetime)
    },
    getErrors: function (field) {
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },
    cancelHandler() {
      this.display = false
    },
  },
}
</script>

<style>
.v-time-picker-title {
  height: 56px !important;
}
.v-input--has-state .v-input__slot:before {
  border-color: rgb(219, 56, 76) !important;
}
</style>

<style scoped>
.v-card {
  box-shadow: none;
}
</style>
